import script from "./Community.vue?vue&type=script&setup=true&lang=ts"
export * from "./Community.vue?vue&type=script&setup=true&lang=ts"

import "./Community.vue?vue&type=style&index=0&id=c9685466&scoped=true&lang=scss"
import "./Community.vue?vue&type=style&index=1&id=c9685466&scoped=true&lang=css"
import "./Community.vue?vue&type=style&index=2&id=c9685466&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9685466"]])

export default __exports__